(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoiceUpdateStatusController',InvoiceUpdateStatusController);

    InvoiceUpdateStatusController.$inject = ['$uibModalInstance','entity','InvoiceMinDTOCustomService','ToastrService'];

    function InvoiceUpdateStatusController($uibModalInstance, entity, InvoiceMinDTOCustomService, ToastrService) {
        var vm = this;

        vm.invStatuses = ['DRAFT','APPROVED','ISSUED'];
        vm.selectedStatus = "ISSUED";

        vm.invoices = entity;

        vm.updateSelectedStatus = updateSelectedStatus;
        vm.updateInvoiceStatus = updateInvoiceStatus;
        vm.clear = clear;

        function updateSelectedStatus(status) {
            vm.selectedStatus = status;
        }

        function updateInvoiceStatus() {
            InvoiceMinDTOCustomService.updateInvoiceStatus(vm.invoices, vm.selectedStatus).then(function(response) {
                ToastrService.success("Successfully updated Invoice Status", "Success!");
                $uibModalInstance.close(response);
            }, function(error) {
                ToastrService.error("Cannot update Invoice status", "Error");
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
